export const PANTHEON_NETWORK_EMBED_PATH = "/embed/pantheon-network";

export function isPantheonNetworkEmbedPath(pathname) {
  const normalized = String(pathname || "").replace(/\/+$/, "") || "/";
  return normalized === PANTHEON_NETWORK_EMBED_PATH;
}
